export default "__VITE_ASSET__BugL2uad__"